import { css } from 'emotion';

export namespace styles {
  export const container = css({
    lineHeight: 1.46,
    padding: '2em'
  });
}
